import { LabelBadge, OptionIcons, OptionWithIcons } from 'components/shared/form/OptionLabel';
import CentralIntakeSvg from 'svg/CentralIntakeIcon';

// Announced as "Central intake" where it marks a group. Decorative next to text that already says so.
export function CentralIntakeIcon({ size = 14, decorative = false }: { size?: number; decorative?: boolean }) {
  const a11yProps = decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Central intake' };

  return <CentralIntakeSvg width={size} height={size} {...a11yProps} />;
}

// The icon with its name, as a field label's legend or beside a group's name.
export function CentralIntakeBadge() {
  return (
    <LabelBadge>
      <CentralIntakeIcon size={12} decorative />
      <span>Central Intake</span>
    </LabelBadge>
  );
}

// A group option's label with the icon when it's its client's central intake group.
export function CentralIntakeOptionLabel({ label, centralIntake }: { label: React.ReactNode; centralIntake: boolean }) {
  if (!centralIntake) return <>{label}</>;

  return (
    <OptionWithIcons>
      {label}
      <OptionIcons>
        <CentralIntakeIcon />
      </OptionIcons>
    </OptionWithIcons>
  );
}
